import gql from 'graphql-tag';

export const GET_CENTRAL_DATA = gql`
query($id: String!) {
    central(id: $id) {
      id
      name
      from
      to
      project {
        name
      }
      crosssections {
        id
        name
        kilometer
        lanes_count
        past_invisible_lanes
        next_invisible_lanes
        ssts {
          id
          name
          position
          cluster {
            id
            name
          }
        }
        devices {
          id
          name
          device_type
          position
          ... on Sign {
            sign_type
            blinking_lights {
              id
            }
          }
        }
        passive_components {
          name
          passive_component_type
          position
          link
        }
      }
    }
}
`;